module.exports = __webpack_public_path__ + "img/performance-test-icon4.3eec69a2.png";